import React from 'react';
import BaseGridToolbar from '../../components/shared/toolbar/BaseGridToolbar';

const ContactListToolbar = ({
  title,
  columns,
  data,
  filterType,
  onFilterTypeChange,
  actionButton
}) => {
  const filterOptions = [
    { value: '', label: 'All Contacts' },
    { value: 'buyer', label: 'Buyers' },
    { value: 'seller', label: 'Sellers' },
    { value: 'both', label: 'Buyers/Sellers' },
    { value: 'auction_house', label: 'Auction Houses' }
  ];

  const customFilters = (
    <select
      value={filterType}
      onChange={(e) => onFilterTypeChange(e.target.value)}
      className="rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
    >
      {filterOptions.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );

  return (
    <BaseGridToolbar
      title={title}
      columns={columns}
      data={data}
      showQuickFilter={true}
      quickFilterProps={{ 
        debounceMs: 300
      }}
      actionButton={actionButton}
      customFilters={customFilters}
    />
  );
};

export default ContactListToolbar;
